import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import styles from "./InspectorProfile.module.css";

function BookingButton() {
    const navigate = useNavigate(); // Initialize the useNavigate hook

    const handleClick = () => {
        navigate("/services/home-inspection-Schedule"); // Navigate to the specified route
    };

    return (
        <button className={`${styles.bookingButton} tw-bg-primary hover:tw-bg-primary_hover`} onClick={handleClick}>
            Select & Book
        </button>
    );
}

export default BookingButton;
